import type { FloatingOptions } from 'react-joyride';

/**
 * Floating UI defaults shared by every guided tour.
 *
 * Joyride's shift middleware only corrects overflow along the placement edge, so
 * a top/bottom-placed tooltip is never pulled back vertically. When the target
 * fills the page — the Changelog DataGrid — flip has no side that fits and the
 * tooltip hangs off-screen (#8626); Joyride's other fallback, scrolling the
 * window to reveal it, never fires under our `100vh; overflow: hidden` shell.
 * crossAxis clamps what's left. It is inert unless the tooltip would overflow,
 * and against a viewport-filling target it lands on top of that target — the
 * tradeoff, since no placement outside such a target fits.
 */
export const TOUR_FLOATING_OPTIONS: FloatingOptions = {
  shiftOptions: { crossAxis: true }
};
